import { createPortal } from "react-dom"
import { store } from "../../app/store"
import { setActive } from "../../app/slices/snackbarItemSlice"
import { Snackbar, SnackbarItem } from "@george-labs.com/design-system"
import { useTranslation } from "react-i18next"

const SnackbarItemComponent = () => {
  const { t } = useTranslation()
  const label =
    store.getState().snackbarItem.label || t("documents.snackbar.download")

  return createPortal(
    <div className="g-bootstrap g-bs4">
      <Snackbar>
        <SnackbarItem
          onClose={() => store.dispatch(setActive(false))}
          className="mt-4"
          variant={SnackbarItem.VARIANT.BUSY}
          message={label}
        >
          {label}
        </SnackbarItem>
      </Snackbar>
    </div>,
    document.body,
  )
}

export default SnackbarItemComponent
